import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import './Home.css';
import Hero from "../components/Hero";

const Home = () => {
    return (
        <div >
            <Hero />
            <Container className="topspace">

                 <Col>
                 <h1>WELCOME TO THE EYE OF CHINA!</h1>
                 </Col>

             <Row>
                 <Col>
                 <p>
                 Is a professional import and export development consulting and advisory company. 
                 </p>
                 <p>
                 It is aimming at helping businessmen who are in importing and exporting business both from South Africa and China to achive their business target. 
                 </p>
             
                 <Button variant="danger">
           Let Us Call You

</Button>
                 </Col>
                 <Col className="main-img">
                 <img src="/assets/images/group1.jpg" />
                
                 </Col>
             </Row>
               
                <Row>
                    <Col>
                    <h2>Why We’re Better?</h2>
                    </Col>
                </Row>

               <Row>
                   <Col className="icon-info" lg="3">
                   <i className="fas fa-box-open"></i>
                       <h3>Source Products</h3>
                   </Col>
                   <Col className="icon-info" lg="3">
                   <i className="fas fa-comments-dollar"></i>
                       <h3>Get Quotations</h3>
                   </Col>
                   <Col className="icon-info" lg="3">
                   <i className="fas fa-city"></i>
                       <h3>Inspect Factories</h3>
                   </Col>
                   <Col className="icon-info" lg="3">
                   <i className="fas fa-people-carry"></i>
                       <h3>Get Samples</h3>
                   </Col>
               </Row>

                

            </Container>

        </div>
    );
};

export default Home;